'use strict';

/**
  * @namespace v3sWbtPlayerApp  
  * @description Der WBT-Player ist ein WBT-Viewer. Er hat die Aufgabe das WBT darzustellen, den Lernprozess zu steuern und Lernstanddaten zu verarbeiten. <br>
  * Die Lernstanddaten können mit der Umgebung (LMS/App/Browser) synchronisiert werden.
  */

var v3sWbtPlayer = [];
angular.module('v3sWbtPlayerApp', ['ui.router', 'LocalStorageModule', 'ngAnimate', 'mgcrea.ngStrap', 'ngSanitize']);